<template>
  <div id="myModal" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="headerWrap">UPDATE GUEST</h2>
        <div class="closeMessageModalWrapper">
          <close-icon @closeEvent="close()" :dark="true"></close-icon>
        </div>
      </div>
      <div class="modal-body">
        <div class="rowWrap">
          <div class="labelWrap">
            <p>GUEST</p>
          </div>
          <div class="inputWrap">
            <input v-model="selectedRoom.roomnumber" placeholder="" disabled />
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="rowWrap">
          <div class="labelWrap">
            <p>FIRST NAME</p>
          </div>
          <div class="inputWrap">
            <input
              v-model="selectedRoom.guestname"
              placeholder="Guest's first name"
            />
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="rowWrap">
          <div class="labelWrap">
            <p>LAST NAME</p>
          </div>
          <div class="inputWrap">
            <input
              v-model="selectedRoom.guestlastname"
              placeholder="Guest's last name"
            />
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="rowWrap">
          <div class="labelWrap">
            <p>E-MAIL</p>
          </div>
          <div class="inputWrap">
            <input
              type="email"
              v-model="selectedRoom.email"
              placeholder="Guest's e-mail address"
            />
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="rowWrap numberInfo">
          <div class="labelWrap">
            <p>PHONE NUMBER</p>
          </div>
          <div class="inputWrap">
            <input
              v-model="selectedRoom.phone"
              placeholder="Guest's phone number"
            />
          </div>
        </div>
        <div class="phoneExample">
          <p>Country code + phone number (Ex: +4531945837)</p>
        </div>
      </div>
      <div class="button-wrap">
        <button-global
          type="positive"
          :text="updateState"
          @eventPassed="updateRoom()"
          :disabled="disabledActive"
        ></button-global>
        <button-global
          type="negative"
          text="CANCEL"
          @eventPassed="close()"
          :disabled="disabledActive"
        ></button-global>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/components/GlobalComponents/CloseIcon";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import bus from "@/bus.js";
import { functions } from "@/firebase";

export default {
  components: {
    CloseIcon,
    ButtonGlobal,
  },
  props: {
    selectedRoom: Object,
  },
  data() {
    return {
      disabledActive: false,
      updateState: "UPDATE",
    };
  },
  mounted: function () {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        bus.$emit("closeUpdateRoomModal");
      }
    });
  },
  destroyed: function () {
    document.removeEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        bus.$emit("closeUpdateRoomModal");
      }
    });
  },
  methods: {
    close() {
      bus.$emit("closeUpdateRoomModal");
    },
    updateRoom() {
      this.updateState = "UPDATING...";
      this.disabledActive = true;

      functions.httpsCallable('manualGuestRegister')({
        customer_id: this.$customerId,
        hotel_id: this.$hotelId,
        action_type: 'roomupdate',
        guest_name: this.selectedRoom.guestname,
        guest_lastname: this.selectedRoom.guestlastname,
        guest_email: this.selectedRoom.email,
        guest_number: this.selectedRoom.phone,
        room_number: this.selectedRoom.roomnumber,
        room_key: this.selectedRoom[".key"]
      })
      .then(
        () => {
          this.updateState = "UPDATE";
          this.disabledActive = false;
          this.$toastEvents.push({
            type: "positive",
            title: "Success",
            content: "Guest information has been updated",
            id: +new Date(),
          });
          bus.$emit("closeUpdateRoomModal");
        },
        () => {
          alert(
            "A problem has occurred on the Server, please try again later."
          );
        }
      );
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
p,
input,
textarea {
  color: #707070;
  font-size: 16px;
  margin: 0;
}

/* The Modal (background) */
.modal {
  position: fixed; /* Stay in place */
  z-index: 910; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0, 0, 0, 0.8); /* Black w/ opacity */
}
.closeMessageModalWrapper {
  position: absolute;
  top: 0px;
  right: 5px;
}
/* Modal Content */
.modal-content {
  position: relative;
  border-radius: 15px;
  background-color: #fefefe;
  margin: auto;
  margin-top: 35px;
  padding: 25px;
  width: 90%;
  max-width: 600px;
}
h2.headerWrap {
  margin-top: 10px;
  margin-bottom: 40px;
  font-size: 32px;
  font-weight: 100;
}
.modal-body {
  margin: 30px 0;
}

/* Form controller */
.inputWrap {
  width: 320px;
}
.inputWrap > input {
  border: 1px solid #707070;
  border-radius: 5px;
  background-color: #ffffff;
  width: 100%;
  padding: 7px 18px;
}
div.numberInfo {
  align-items: flex-start;
}
div.numberInfo > div.labelWrap {
  margin-top: 10px;
}
div.numberInfo > div.inputWrap > p {
  margin: 10px 0;
  text-align: left;
}
div.phoneExample > p {
  text-align: right;
  margin-top: 15px;
}
.rowWrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.labelWrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.button-wrap {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 426px) {
  /* Modal Content */
  .modal-content {
    padding: 15px;
  }
  h2.headerWrap {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 24px;
  }

  .inputWrap {
    width: 100%;
  }
  .rowWrap {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;
  }
  .labelWrap {
    margin-bottom: 10px;
  }
}
</style>
